// Material helpers
import { createMuiTheme } from '@material-ui/core';

import typography from '../common/typography';
import overrides from '../common/overrides';
import palette from './palette';

const theme = createMuiTheme({
  palette,
  typography,
  overrides,
  // zIndex: {
  //   appBar: 1200,
  //   drawer: 1100
  // }
});

export default theme;
